import React from 'react';


const CustomButton = ({ onClick, loading, children ,className}) => (
  
  <button  onClick={onClick} disabled={loading} className={className} >
    {loading ? 'Downloading...' : children}
  </button>
);

export default CustomButton;
